// Preços da vitrine lidos da API de créditos, em vez de escritos no HTML.
// A cada assembleia o prazo restante dos grupos cai e a parcela muda; com o valor fixo
// no HTML a página passava a anunciar parcela menor que a real (medido em 23/09/2026).
// Sem import de propósito: roda no `node --test` sem Vite.

// ponytail: tolerância fixa de 6 assembleias; um grupo mais velho que isso some da aba
// e vira "Consulte", sinal de que falta cadastrar grupo novo no painel Grupo cotas.
const TOLERANCIA_PRAZO = 6

// A API mistura formatos no mesmo registro: crédito "10.000,00", parcela "411.87".
export function valor(texto) {
    const s = String(texto ?? '').replace(/[^\d.,]/g, '')
    if (!s) return null
    // Sem vírgula, ponto seguido de 3 dígitos é milhar ("1.000"), não decimal.
    const ptBr = s.includes(',') || /^\d{1,3}(\.\d{3})+$/.test(s)
    const n = ptBr ? Number(s.replace(/\./g, '').replace(',', '.')) : Number(s)
    return Number.isFinite(n) ? n : null
}

function doCredito(planos, credito) {
    return planos.filter((p) => valor(p.credito) === credito && valor(p.restanteParcela) > 0)
}

function menor(planos) {
    return planos.length ? Math.min(...planos.map((p) => valor(p.restanteParcela))) : null
}

// Parcela recorrente; a primeira é reduzida e não serve de "a partir de".
export function menorParcela(planos, credito) {
    return menor(doCredito(planos, credito))
}

export function parcelaDoPrazo(planos, credito, prazoAlvo) {
    const candidatos = doCredito(planos, credito).filter((p) => {
        const prazo = Number(p.prazo)
        return prazo <= prazoAlvo && prazo >= prazoAlvo - TOLERANCIA_PRAZO
    })
    if (!candidatos.length) return null
    const maiorPrazo = Math.max(...candidatos.map((p) => Number(p.prazo)))
    return menor(candidatos.filter((p) => Number(p.prazo) === maiorPrazo))
}

const inteiro = new Intl.NumberFormat('pt-BR', {maximumFractionDigits: 0})
const centavos = new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})

// Elementos marcados com data-preco-credito (e data-preco-prazo, nas tabelas).
export function aplicarPrecos(root, planos) {
    if (!Array.isArray(planos) || !planos.length) return
    for (const el of root.querySelectorAll('[data-preco-credito]')) {
        const credito = Number(el.dataset.precoCredito)
        const prazo = el.dataset.precoPrazo ? Number(el.dataset.precoPrazo) : null
        const parcela = prazo ? parcelaDoPrazo(planos, credito, prazo) : menorParcela(planos, credito)
        if (parcela == null) el.textContent = 'Consulte'
        // Cartão arredonda para cima: nunca anunciar abaixo do que o cliente paga.
        else el.textContent = prazo ? `R$ ${centavos.format(parcela)}` : `R$ ${inteiro.format(Math.ceil(parcela))}`
    }
}
